import { render } from "./vital-sign-button.vue?vue&type=template&id=3f439df7&scoped=true"
import script from "./vital-sign-button.vue?vue&type=script&lang=js"
export * from "./vital-sign-button.vue?vue&type=script&lang=js"

import "./vital-sign-button.vue?vue&type=style&index=0&id=3f439df7&scoped=true&lang=css"

import exportComponent from "/Users/qmaura/PANOPTIC/lify-blends-recommender/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f439df7"]])

export default __exports__